<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')">
      <template v-slot:title>
        <small v-if="id"> ({{ id }})</small>
        {{ data.name ? "" + data.name : "Создание регулярной задачи" }}
      </template>
      <v-row>
        {{ data }}
        <v-col cols="12">
          <a-form-model v-model="data" :model="model" :errors="errors" @validate="validate($event)" />
        </v-col>
        <v-col cols="3">
          <v-radio-group v-model="cronType">
            <v-radio v-for="el in cronHeader" :key="el.value" :label="el.text" :value="el.value"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="9">
          <a-cron-weekly v-if="cronType == 1" :value="data.cron_data" @change-val="changeVal" />
          <a-cron-monthly v-if="cronType == 2" :value="data.cron_data" @change-val="changeVal" />
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save @click="submit_()" v-if="getAccess('task.edit', { users: [data.user_id, user_id] }) || !id" />
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess } from "../../components/mixings";

export default {
  mixins: [getForm, submitForm, removeEl, getAccess],
  props: {
    value: Boolean,
    id: Number,
    task: Object,
  },
  data() {
    return {
      valueCron: ["*", "*", "*", "*", "*", "*", "*"],
      m: JSON.parse(JSON.stringify(this.$store.getters["config/get"].models.cron)),
      cronType: null,
      cronHeader: [
        { value: "1", text: "Каждую неделю" },
        { value: "2", text: "Каждый месяц" },
      ],
      api: "/mechti/cron_tasks",
      user_id: null,
      defaults: {
        date_event: new Date(),
        user_id: this.$root.profile.id,
        is_important: 2,
        status: 0,
      },
      suEditShow: false,
    };
  },
  computed: {
    model() {
      let model = JSON.parse(JSON.stringify(this.m.form));
      model.forEach(el => {
        if (el?.sourceList) el.options = this.m[el.sourceList];
      });
      return model;
    },
  },
  watch: {
    value() {
      if (this.value) {
        this.updateData(this.id);
        this.user_id = this.data.user_id;
        if (this.id) {
        } else {
          this.data.nextevent = new Date().date;
        }
      }
    },
  },
  created() {
    this.makeObjectModel();
  },
  methods: {
    submit_() {
      let cron = JSON.parse(JSON.stringify(this.data));
      if (this.cronType == 1) {
        if (!cron.cron_data.dow || !cron.cron_data.dow.length) {
          this.$root.$emit("show-info", {
            text: "Не выбраны дни недели для расписания",
            type: "error",
          });
          return;
        }
        cron.cron_data.mon = null;
        cron.cron_data.dom = null;
      } else if (this.cronType == 1) {
        if (!cron.cron_data.mon || !cron.cron_data.mon.length) {
          this.$root.$emit("show-info", {
            text: "Не выбраны месяцы",
            type: "error",
          });
          return;
        }
        if (!cron.cron_data.dom || !cron.cron_data.dom.length) {
          this.$root.$emit("show-info", {
            text: "Не выбраны числа",
            type: "error",
          });
          return;
        }
        cron.cron_data.dow = null;
      } else {
        this.$root.$emit("show-info", {
          text: "Не настроено расписание",
          type: "error",
        });
        return;
      }
      cron.cron_data.l = 360;
      cron.cron_data.m = 1;
      cron.cron_data.h = 0;
      cron.task_data = {};
      for (const key of this.m.taskData) {
        if (this.task?.[key]) {
          cron.task_data[key] = this.task[key];
        }
      }
      cron.task_data.status = 0;
      console.log(cron);
      this.data = cron;
      this.submit();
    },
    changeVal(val) {
      this.data.cron_data[val.name] = val.value;
      console.log(val, this.data.cron_data);
    },
    afterFetchData() {},
    afterRemove(data) {
      this.removeDialogShow = false;
      this.$emit("input");
    },
    afterSave(data, status) {
      if (status) {
        this.$emit("input");
      }
    },
  },
};
</script>
<style lang="sass"></style>
